import { MenuItem, Select } from '@mui/material';
import type { FC } from 'react';
import { LAYER_INDICATORS, LayerKey } from '../../../../core/mapV2/indicators';
import { layerIndicatorSet } from '../../../../core/mapV2/state';
import { useAppDispatch } from '../../../../types';

type Props = {
    layer: LayerKey;
    value: string;
    ariaLabel: string;
};

// Single choice. "–" is the first entry: on the displayed layer it hides the layer.
export const IndicatorSelect: FC<Props> = ({ layer, value, ariaLabel }) => {
    const dispatch = useAppDispatch();

    return (
        <Select
            fullWidth
            size="small"
            value={value}
            inputProps={{ 'aria-label': ariaLabel, 'data-testid': `map-v2-indicator-${layer}` }}
            onChange={(event) => dispatch(layerIndicatorSet({ layer, indicator: event.target.value }))}
            sx={{ height: 36, fontSize: 13 }}
        >
            {LAYER_INDICATORS[layer].map((indicator) => (
                <MenuItem key={indicator} value={indicator} sx={{ fontSize: 13 }}>
                    {indicator}
                </MenuItem>
            ))}
        </Select>
    );
};
